import { configureStore } from "@reduxjs/toolkit";
import login from "../redux/slices/auth";
import createsettings from "../redux/slices/createSettings";
import getsettingsslice from "../redux/slices/getsettings";
import Updatesettingslice from "../redux/slices/updateSettings";
import CashoutSlice from "../redux/slices/cashouts";
import offcanvas from "../redux/slices/offcanvas";
import model from "../redux/slices/model";
import tablecontent from "../redux/slices/tablecontent";
import pay_triger from "../redux/slices/pay_trigger";
import attachments from "../redux/slices/attachments";
import agent from "../redux/slices/agentresponce";
import tabs from "../redux/slices/tabs";
import deposits from "../redux/slices/depositlist";
import depositsresponce from "../redux/slices/depositsresponce";
import getGames from "../redux/slices/cg";
import Creategames from "../redux/slices/creategame";
import GetRefreshBalance from "../redux/slices/UpdateBalance";
import ResetPasswordSlice from "../redux/slices/ResetPassword";
import RedeemSlice from "../redux/slices/RedeemRequests";
import gameDeposits from "../redux/slices/gamedeposits";
import SignupSlice from "../redux/slices/createUserAccount";
import dashboardstatus from "../redux/slices/dashboard";
import active from "../redux/slices/active";
import transpicture from "../redux/slices/transpicture";
import userActive from "../redux/slices/activeUsers";
import allcus from "../redux/slices/allcus";
import payment from "../redux/slices/payment";
import website from "../redux/slices/website";
import blog from "../redux/slices/blog";

export default configureStore({
  reducer: {
    login: login,
    csr: createsettings,
    gsr: getsettingsslice,
    usr: Updatesettingslice,
    cashouts: CashoutSlice,
    rtl: offcanvas,
    model: model,
    toc: tablecontent,
    pay: pay_triger,
    files: attachments,
    agent: agent,
    key: tabs,
    deposits: deposits,
    agentdeposits: depositsresponce,
    ggames: getGames,
    cg: Creategames,
    refreshBalance: GetRefreshBalance,
    resetPassword: ResetPasswordSlice,
    redeem: RedeemSlice,
    gameDepostis: gameDeposits,
    createuser: SignupSlice,
    status: dashboardstatus,
    active: active,
    onlines: userActive,
    transpic: transpicture,
    allcus: allcus,
    payment: payment,
    website: website,
    blog,
  },
});
